import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Trainers from "./Trainers";

class TrainersScreen extends React.Component {
  render() {
    return (
      <div>
        <Router>
          <Switch>
          <Route exact={true} path="/" component={Trainers} />
            <Route exact={true} path="/trainers/" component={Trainers} />
          </Switch>
        </Router>
      </div>
    );
  }
}

export default TrainersScreen;
